<div class="cell-name bold uppercase" [tiimeTooltip]="prospect.fullName" tooltipHideWithoutEllipsis>
  {{ prospect.fullName }}
</div>
<div class="cell-infos">
  @if (prospect.companyLegalForm) {
    {{ prospect.companyLegalForm }}
  }
  @if (prospect.companyLegalForm && prospect.companyName) {
    &nbsp;&#8226;&nbsp;
  }
  @if (prospect.companyName) {
    {{ prospect.companyName }}
  }
</div>
